import { lazy, Suspense, type ComponentType } from "react";
import { Routes, Route } from "react-router-dom";
import { Landing } from "./pages/Landing";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { PageLoader } from "./components/PageLoader";

// Landing loads eagerly since it's the entry point for almost every
// visitor; everything else is route-split so the marketing page doesn't
// ship the merchant dashboard, admin panel, and every other page's code
// on first load.
function lazyNamed<M extends Record<string, ComponentType>>(loader: () => Promise<M>, name: keyof M) {
  return lazy(() => loader().then((m) => ({ default: m[name] })));
}

const MentionsLegales = lazyNamed(() => import("./pages/MentionsLegales"), "MentionsLegales");
const Confidentialite = lazyNamed(() => import("./pages/Confidentialite"), "Confidentialite");
const Admin = lazyNamed(() => import("./pages/Admin"), "Admin");
const MerchantSpace = lazyNamed(() => import("./pages/MerchantSpace"), "MerchantSpace");
const CustomerCard = lazyNamed(() => import("./pages/CustomerCard"), "CustomerCard");
const WheelGame = lazyNamed(() => import("./pages/WheelGame"), "WheelGame");
const AvisPage = lazyNamed(() => import("./pages/AvisPage"), "AvisPage");
const RdvPage = lazyNamed(() => import("./pages/RdvPage"), "RdvPage");
const MerchantWebsite = lazyNamed(() => import("./pages/MerchantWebsite"), "MerchantWebsite");
const Signup = lazyNamed(() => import("./pages/Signup"), "Signup");
const Decouvrir = lazyNamed(() => import("./pages/Decouvrir"), "Decouvrir");
const MyAccountPage = lazyNamed(() => import("./pages/MyAccountPage"), "MyAccountPage");
const Changelog = lazyNamed(() => import("./pages/Changelog"), "Changelog");
const NotFound = lazyNamed(() => import("./pages/NotFound"), "NotFound");

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/commercant" element={<MerchantSpace />} />
          <Route path="/commercant/:merchantId" element={<MerchantSpace />} />
          <Route path="/carte/:merchantId" element={<CustomerCard />} />
          <Route path="/roue/:merchantId" element={<WheelGame />} />
          <Route path="/avis/:merchantId" element={<AvisPage />} />
          <Route path="/rdv/:merchantId" element={<RdvPage />} />
          <Route path="/site/:merchantId" element={<MerchantWebsite />} />
          <Route path="/inscription" element={<Signup />} />
          <Route path="/decouvrir" element={<Decouvrir />} />
          <Route path="/mon-compte/:merchantId" element={<MyAccountPage />} />
          <Route path="/nouveautes" element={<Changelog />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
